<!-- 表格 -->
<template>
  <div class="table-comp">
    <div class="table">
      <!-- 表格头-->
      <slot />
      <ul class="table-header">
        <li
          v-for="(value, key, index) in tableObj.tableHeader"
          :key="index"
          class="table-header-item"
          :style="value.style"
        >
          {{ value.name }}
        </li>
      </ul>
      <div v-loading="tableLoading" class="table-body-box">
        <!-- 没有数据 -->
        <div v-if="tableObj.tableData.length === 0" class="table-noData">
          <img
            class="table-noData-img"
            src="https://vfiles.gtimg.cn/vupload/20200731/ebbb101596195648710.png"
          />
          <div class="table-noData-word">暂无相关内容</div>
        </div>
        <!-- 表格体 -->
        <ul v-else class="table-body" v-for="(item1, index1) in tableObj.tableData" :key="index1">
          <li
            v-for="(value, key, index2) in tableObj.tableHeader"
            :key="index2"
            class="table-body-item"
            :style="value.style"
          >
            <!-- 表格数据 -->
            <div v-if="key !== 'operation'" :class="['table-body-item-inner', value.className]">
              <template v-if="value.render">
                <div
                  v-if="value.click"
                  class="text"
                  @click="value.click(item1[key])"
                  v-html="value.render(item1[key], item1)"
                />
                <div v-else v-html="value.render(item1[key], item1)" class="text" />
                <span
                  v-if="value.tipText && value.tipText(item1[key], item1).length"
                  class="toolTip"
                >
                  {{ value.tipText(item1[key], item1) }}
                </span>
              </template>
              <template v-else>
                <span v-if="value.click" class="text" @click="value.click(item1[key])">
                  {{ item1[key] ? item1[key] : '-' }}
                </span>
                <span v-else class="text">{{ item1[key] ? item1[key] : '-' }}</span>
                <span
                  v-if="value.tipText && value.tipText(item1[key], item1).length"
                  class="toolTip"
                >
                  {{ value.tipText(item1[key], item1) }}
                </span>
              </template>
            </div>
            <!-- 如果是操作数据 -->
            <div v-else class="table-body-item-inner operation">
              <div
                v-for="(item3, index3) in item1[key]"
                :key="index3"
                class="table-body-item-txt"
                @click="event(item1, $event)"
                v-html="item3"
              />
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- v-if="tableObj.tableTotal-tableObj.tablePageSize > 0" -->
    <el-pagination
      class="pagination"
      style="background-color: #fff"
      layout="total, prev, pager, next, jumper"
      :total="tableObj.tableTotal"
      :page-size="tableObj.tablePageSize"
      :current-page="tableObj.tablePageIndex"
      @current-change="currentChangeFun"
    />
  </div>
</template>
<script>
export default {
  name: 'TableComp',
  props: {
    // 表格配置对象
    tableObj: {
      type: Object,
      default: () => ({
        tableHeader: {}, // 表格头
        tableData: [], // 内容数据
        tableTotal: 0, // 总数
        tablePageSize: 10, // 每页条数
        tablePageIndex: 1, // 当前页
      }),
    },
    // 表格加载
    tableLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    // 获取点击事件的文字传递给父组件
    event(row, $event) {
      this.$emit('operationEmit', {
        row,
        innerHTML: $event.target.innerHTML,
      });
    },
    // 切换页触发事件
    currentChangeFun(e) {
      this.$emit('paginationEmit', e);
    },
  },
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
